import { render } from "./Acessibilidade.vue?vue&type=template&id=f30d1e98"
import script from "./Acessibilidade.vue?vue&type=script&lang=js"
export * from "./Acessibilidade.vue?vue&type=script&lang=js"

import "./Acessibilidade.vue?vue&type=style&index=0&id=f30d1e98&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__